import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { CarouselSelect } from "./CarouselSelect";

export enum CarouselElementMode
{
  Portrait,
  Landscape,
  PortraitLandscape
}

export abstract class CarouselElement
{ 
  protected _carouselSelectElement:CarouselSelect;
  protected _element:Element;
  get element(){ return this._element; }
  protected _mode:CarouselElementMode;
  get mode() { return this._mode; }

  constructor( cse:CarouselSelect, element:Element, mode:CarouselElementMode )
  {
    this._carouselSelectElement = cse;
    this._element = element;
    this._mode = mode;
  }

  get transitionOutDuration():number
  {
    return 0.5;
  }

  get transitionOutDurationMs():number
  {
    return this.transitionOutDuration * 1000;
  }

  get transitionInDuration():number
  {
    return 0.5;
  }

  get transitionInDurationMs():number
  {
    return this.transitionInDuration * 1000;
  }

  abstract transitionOut():Promise<void>
  abstract transitionIn():Promise<void>
}